const dashboardtxt = {
    welcome: "Velkomin",
    hello: "Halló",
    logout: "Log out",
    thisisyourprivateaccount: "Þú ert með einkareikning, vinsamlegast skaltu skipta yfir í fullan reikning til að fá aðgang að viðburðum, fá möguleika á að rukka auglýsingar og fleira.",
    userdashboard: "Stillingar notanda",
    importevents: "Flytja inn viðburði",
    importeventsdescription: "Afritaðu slóðina á viðburðinn - eða viðburðasíðuna þína - og límdu hana hér að neðan. Við munum skanna síðuna og flytja inn viðburðina þína.",

    howdoesthisallwork: "Hvernig hangir þetta saman?",
    wanttosignup: "Viltu vera memm?",
    makesureyourevents: "Sjáðu til þess að viðburðirnir þínir séu í safninu, rétt flokkaðir og auglýstir á réttum stöðum.",
    itsallfreeexcept: "Aðgangur er ókeypis, skráning viðburða er ókeypis. Auglýsingarnar ekki og API þjónustan ekki heldur.",
    firstwasnothing: "Fyrst var ekkert - svo komst þú.",
    youasyou: "Þú sem einstaklingur, sem getur leikið mörg hlutverk.",
    homebythesea: "Ég byggði mér hús við hafið.",
    theonethatpaysthebills: "Það er fullur aðgangur. Þessi sem borgar reikningana. Eða á að halda utan um viðburði. Það getur verið bandið, eða húsið, eða tónleikahaldarinn, eða sveitarfélagið. Þú getur átt fleiri en einn svoleiðis, ef þú ert að vinna með fleiri en einn listamann, eða staði, eða vefsíður. Þú getur veitt öðrum aðgang og þegar trommarinn hættir þá geturðu tekið hann af listanum og sett þann nýja í staðinn.",
    onemorenight: "Enn einn túrinn.",
    fullaccountscan: "Fullir aðgangar geta síðan sótt um að fá leyfi til að breyta viðburðum í viðburðasafninu okkar - eða stofna þá. Það skiptist í þrennt; að möndla með viburði fyrir stað, eða fyrir listamann, eða staka viðburði.",
    eventsallover: "Upplýsingar úr viðburðasafninu birtast á vefsíðum víða um heim, og í gegnum API þjónustu okkar.",

    frontpageheadline: "Gervigreinda viðburðasafnið",
    uptodateeventinfo: "Viðburðir, flokkaðir eftir kúnstarinnar reglum. Til birtingar út um allt.",
    formedia: "Fyrir fjölmiðla og vefsíður",
    forperformers: "Fyrir hljómsveitir, listamenn og aðra sem stíga á svið",
    forvenues: "Fyrir húsin þar sem allt gerist",
    usingscripts: "Using scripts",
    usingAPI: "Using API",

    forvenuestitle: "Sjáðu til þess að viðburðirnir séu uppfærðir til birtinga á vefsíðum og í öppum",
    forperformerstitle: "Sjáðu til þess að viðburðirnir séu uppfærðir, flokkaðir og auglýstir",
    formediatitle: "Bætt tekjustreymi með viðburðaskráningu og sjálfsafgreiðslu á viðburðaauglýsingum",
    forvenuesslug: "Breyttu eða bættu við viðburðum. Ef þú ert með vefsíðu með viðburðum þá geturðu skráð hana hjá okkur og við skráum viðburðina þína sjálfkrafa. ",
    forperformersslug: "Sjáðu til þess að viðburðirnir séu réttir og rétt flokkaðir. Eru þeir túristavænir? Fyrir eldri borgara? Eða fyrir börn? Við hjálpum þér að flokka þá rétt. ",
    formediaslug: "Viðburðalistar eru góð viðbót við vefsíður. Ekki skemmir fyrir ef þeim fylgja auglýsingar. Fáðu viðburðalista og tekjuskiptingu fyrir auglýsingar. Þú sérð um plássið.",


    dashboard: "Dashboard",
    getstarted: "Get started",

};
export default dashboardtxt;
